import React from 'react';
import { DRAWING_LEVELS, getDrawingUrl } from '../config/drawings';
import CachedImage from './helpers/CachedImage';

// デッサン画像を1枚表示する。画像は事前生成した public/dessin/ のもの（正本は config/drawings.js）。
// initialImageUrl が渡されればそれを優先する（DrawingPrepare で用意した画像を渡す画面用）。
// shearValue を省くと誤りモデルは「誤り」の画像になる（ジオメトリファクトリの既定 0.5 と同じ）。
// 表示は先読みした画像から行い、読めなければ再試行する（CachedImage。一度の失敗で「画像がない」のままにしない）。
function DrawingViewer({ glbPath, shearValue, initialImageUrl }) {
  const level = shearValue === DRAWING_LEVELS.mid ? 'mid' : 'error';
  const src = initialImageUrl || getDrawingUrl(glbPath, level);

  return (
    <div className="relative">
      <CachedImage src={src} alt="デッサン" />
    </div>
  );
}

export default DrawingViewer;
